import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const FormTemplateSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to Document Fill now' onButtonClick={() => navigate(0)} />
}
